<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Eye, ShieldCheck, Brain } from "lucide-vue-next";
import AnimatedSection from "./AnimatedSection.vue";

const { t } = useI18n();

const propositions = computed(() => [
  {
    icon: Eye,
    title: t("landing.value.items.monitoring.title"),
    description: t("landing.value.items.monitoring.description"),
  },
  {
    icon: ShieldCheck,
    title: t("landing.value.items.security.title"),
    description: t("landing.value.items.security.description"),
  },
  {
    icon: Brain,
    title: t("landing.value.items.ai.title"),
    description: t("landing.value.items.ai.description"),
  },
]);
</script>

<template>
  <section class="py-24 bg-background relative">
    <!-- Subtle top border glow -->
    <div class="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-accent/20 to-transparent" />
    
    <div class="container mx-auto px-6">
      <!-- Section title -->
      <AnimatedSection animation="fade-up">
        <h2 class="text-3xl md:text-4xl font-bold text-foreground text-center mb-16">
          {{ t("landing.value.title") }}
        </h2>
      </AnimatedSection>

      <!-- Three columns -->
      <div class="grid md:grid-cols-3 gap-8 lg:gap-12">
        <AnimatedSection 
          v-for="(prop, index) in propositions"
          :key="index"
          animation="fade-up"
          :delay="index * 150"
        >
          <div class="group p-8 rounded-lg metallic-surface border border-border/50 card-hover h-full">
            <!-- Icon -->
            <div class="mb-6 relative">
              <div class="w-14 h-14 rounded-lg bg-background/50 border border-accent/30 flex items-center justify-center cyan-border-glow">
                <component :is="prop.icon" class="w-7 h-7 text-accent" />
              </div>
            </div>

            <!-- Title -->
            <h3 class="text-xl font-semibold text-foreground mb-4">
              {{ prop.title }}
            </h3>

            <!-- Description -->
            <p class="text-muted-foreground leading-relaxed">
              {{ prop.description }}
            </p>
          </div>
        </AnimatedSection>
      </div>
    </div>
  </section>
</template>
